// /* eslint-disable no-unused-expressions */
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import Loading from "../../../components/shared/loading/Loading";
// import { deleteData } from "../../../hooks/delete";
// import useFetch from "../../../hooks/useFetch";
// import { apiPath, clientSideUrl } from "../../../utility/Constant";
// import ManagementsCard from "./ManagementsCard";

// const ManagementsListPage = () => {
//   const { managementsApi } = apiPath;
//   const { clientManagement } = clientSideUrl;
//   const [managementsListData, managementsListLoading] =
//     useFetch(managementsApi);
//   const [filteredData, setFilteredData] = useState();

//   useEffect(() => {
//     setFilteredData(
//       managementsListData?.filter((item) => item.slug === "content")
//     );
//   }, [managementsListData]);

//   if (managementsListLoading) {
//     return <Loading />;
//   }

//   async function handleSingleDelete(id) {
//     const swalResponse = await Swal.fire({
//       title: "Are you sure you want to delete this?",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       showLoaderOnConfirm: true,
//       preConfirm: async () => {
//         return await deleteData(managementsApi, id);
//       },
//       allowOutsideClick: () => !Swal.isLoading(),
//     });
//     return swalResponse?.value?._id?.length > 0;
//   }

//   return (
//     <div>
//       <div className="mb-2 w-full text-right font-semibold text-sm">
//         <Link
//           className="text-black hover:text-[#DB0029]"
//           to={clientManagement}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Visit page
//           <span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={1.5}
//               stroke="currentColor"
//               className="inline w-4 h-4 ml-1 align-text-top"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
//               />
//             </svg>
//           </span>
//         </Link>
//       </div>
//       <h1 className="font-oswald font-bold text-2xl mt-8 mb-4 uppercase">
//         MANAGEMENT TEAM
//       </h1>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-8">
//         <ManagementsCard />
//         {filteredData.map((item, idx) => (
//           <ManagementsCard
//             key={idx}
//             project={item}
//             user={"admin"}
//             handleSingleDelete={handleSingleDelete}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ManagementsListPage;



/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
import ManagementsCard from "./ManagementsCard";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { MdDragIndicator } from "react-icons/md";
import { motion } from "framer-motion";

const ManagementsListPage = () => {
  const { managementsApi } = apiPath;
  const { clientManagement } = clientSideUrl;
  const [managementsListData, managementsListLoading] = useFetch(managementsApi);
  const [filteredData, setFilteredData] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [updatedOrder, setUpdatedOrder] = useState(null);
  const { aboutUsManagementsList } = RoutePath;


  useEffect(() => {
    const contentList = managementsListData?.filter((item) => item.slug === "content") || [];
    setFilteredData(contentList);
    setOrderList(contentList);
  }, [managementsListData]);

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(managementsApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?._id?.length > 0;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMoveImmutable(orderList, oldIndex, newIndex);
    setOrderList(newOrder);
    const payload = newOrder.map((item, idx) => ({
      _id: item._id,
      orderId: idx + 1,
    }));
    setUpdatedOrder(payload);
  };

  const updateOrderToDB = () => {
    updateData("reorder/managements", updatedOrder);
    setTimeout(() => {
      setUpdatedOrder(null);
      window.location.href = "/" + aboutUsManagementsList;
    }, 800);
  };

  const DragHandle = SortableHandle(() => (
    <div className="absolute top-1 left-1 z-10 bg-white bg-opacity-80 rounded-full p-1">
      <MdDragIndicator className="text-gray-600 cursor-move" size={20} />
    </div>
  ));

  const SortableItem = SortableElement(({ item }) => (
    <ManagementsCard
      key={item._id}
      project={item}
      user={"admin"}
      handleSingleDelete={handleSingleDelete}
      dragHandle={<DragHandle />}
    />
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div className="select-none grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-8">
      <ManagementsCard /> {/* Add New Button Card */}
      {items.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </div>
  ));

  if (managementsListLoading) return <Loading />;

  return (
    <div>
      <div className="flex justify-between items-center flex-wrap gap-4 mb-8">
        <h1 className="font-oswald font-bold text-2xl mt-2 uppercase">
          MANAGEMENT TEAM
        </h1>
        <div className="text-right font-semibold text-sm">
          <div className="flex justify-end items-center gap-4">
            {updatedOrder && (
              <motion.button
                onClick={updateOrderToDB}
                type="button"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="btn border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:bg-[#DB0029] px-3 py-1.5 rounded-xl"
              >
                Save Changes
              </motion.button>
            )}
            <Link
              className="text-black hover:text-[#DB0029]"
              to={clientManagement}
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit page
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="inline w-4 h-4 ml-1 align-text-top"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </div>


      </div>

      <SortableList items={orderList} onSortEnd={onSortEnd} axis="xy" useDragHandle />
    </div>
  );
};

export default ManagementsListPage;
